import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, ProtectedRoute } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";

import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import DashboardPage from "./pages/DashboardPage";
import GeneratePage from "./pages/GeneratePage";
import HistoryPage from "./pages/HistoryPage";
import VideoPage from "./pages/VideoPage";
import SocialToolsPage from "./pages/SocialToolsPage";
import FavoritesPage from "./pages/FavoritesPage";
import ReferralsPage from "./pages/ReferralsPage";
import PricingPage from "./pages/PricingPage";
import SettingsPage from "./pages/SettingsPage";
import AdminPage from "./pages/AdminPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import SubscriptionPage from "./pages/SubscriptionPage";
import SubscriptionSuccessPage from "./pages/SubscriptionSuccessPage";
import DeveloperPage from "./pages/DeveloperPage";
import CreatorClonePage from "./pages/CreatorClonePage";
import TrendRadarPage from "./pages/TrendRadarPage";
import AutopsyPage from "./pages/AutopsyPage";
import PublicAutopsyPage from "./pages/PublicAutopsyPage";
import FoundersPage from "./pages/FoundersPage";
import RoastPage from "./pages/RoastPage";
import NegativeResponsePage from "./pages/NegativeResponsePage";
import BusinessAdsPage from "./pages/BusinessAdsPage";
import PublicBusinessAdsPage from "./pages/PublicBusinessAdsPage";
import AffiliatePage from "./pages/AffiliatePage";
import { AutopsyWallListPage, AutopsyWallDetailPage } from "./pages/AutopsyWallPage";
import TeamPage from "./pages/TeamPage";
import AcceptInvitePage from "./pages/AcceptInvitePage";

const toastStyle = {
  style: { fontFamily: "'IBM Plex Sans', sans-serif", borderRadius: 0, border: "1px solid #e4e4e7" },
};

const PROTECTED_ROUTES = [
  { path: "/dashboard", Component: DashboardPage },
  { path: "/generate", Component: GeneratePage },
  { path: "/history", Component: HistoryPage },
  { path: "/video", Component: VideoPage },
  { path: "/social", Component: SocialToolsPage },
  { path: "/favorites", Component: FavoritesPage },
  { path: "/referrals", Component: ReferralsPage },
  { path: "/pricing", Component: PricingPage },
  { path: "/subscription", Component: SubscriptionPage },
  { path: "/subscription/success", Component: SubscriptionSuccessPage },
  { path: "/developer", Component: DeveloperPage },
  { path: "/clone", Component: CreatorClonePage },
  { path: "/trends", Component: TrendRadarPage },
  { path: "/autopsy", Component: AutopsyPage },
  { path: "/roast", Component: RoastPage },
  { path: "/negative", Component: NegativeResponsePage },
  { path: "/business/ads", Component: BusinessAdsPage },
  { path: "/business/team", Component: TeamPage },
  { path: "/settings", Component: SettingsPage },
  { path: "/admin", Component: AdminPage },
  { path: "/payment/success", Component: PaymentSuccessPage },
];

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <Toaster position="top-right" toastOptions={toastStyle} />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/try" element={<PublicAutopsyPage />} />
            <Route path="/autopsy-demo" element={<PublicAutopsyPage />} />
            <Route path="/founders" element={<FoundersPage />} />
            <Route path="/business/ads/try" element={<PublicBusinessAdsPage />} />
            <Route path="/affiliate" element={<AffiliatePage />} />
            <Route path="/wall" element={<AutopsyWallListPage />} />
            <Route path="/wall/:id" element={<AutopsyWallDetailPage />} />
            <Route path="/team/accept/:token" element={<AcceptInvitePage />} />
            {PROTECTED_ROUTES.map(({ path, Component }) => (
              <Route
                key={path}
                path={path}
                element={
                  <ProtectedRoute>
                    <Component />
                  </ProtectedRoute>
                }
              />
            ))}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
